const zh = {
    langs: {
        homepower: "首页",
        sitetitle: "傲雷新能源科技官网",
        productctr: "产品中心",
        centerpower: "储能电池箱",
        outdoorpower: "户外储能电源",
        centerbms: "智能家储电池板",
        centermotorcycle: "两轮/三轮车BMS",
        centercloud: "云平台",
        cloudplatform: "云平台",
        centerwifi: "通讯模块",
        communication: "通讯模块",
        companyIntroduction: "企业简介",
        onlineEnquiry: "在线询盘",
        online: "在线咨询",
        args_lan: "zh",
        cooperateChain: "合作加盟",
        highvoltage: "高压电池新技术",
        automotivebms: "车用BMS",
        mainfunction: "主要功能",
        maintechnical: "主要技术参数",
        automotivebmsmemo: "傲雷能源科技的低速车系列电池管理系统（BMS）由一个集中式（主从一体机式）BMS，可扩展采集模块，主要用于对中小型叉车、光伏储能、家庭储能、UPS电源管理。该系列产品可对系统电池参数进行实时监控、故障诊断、SOC估算、短路保护、充放电控制、均衡等实时管理，并通过CAN、485通信方式与集成控制器、光伏充电机、充放电设备、人机界面等进行信息交互，保障电池系统高效、可靠、安全运行。",
        monitoringofsystem: "对系统电池参数进行实时监控、故障诊断、SOC估算、短路保护、充放电控制、均衡等实时管理",
        highstoragembs: "高压储能BMS",
        softwarecamera: "具有云端监控的上机位软件保护参数可灵活修改，数据可保存50年不丢失",
        aboutus: "关于我们",
        storageinverter: "WiFi模块在逆变器和BMS没有按键和显示屏的情况下，通过手机APP或平板电脑连接逆变器的solar-wifi进行相关工作模式的设置，可实现本地配置，同时WiFi模块还可远程监控组网，实现峰谷负荷调度。WiFi模块还实现固件升级等",
        aolei: "傲雷能源",
        connectpc: "连接手机或平板",
        nemotenetwork: "远程监控组网",
        energystoragebatterybox: "新型储能电池箱包括散热装置,出风管道和与出风管道连接的气体组件与支撑柱一端连通,气体组件依次通过出风管道.所述散热孔形成散热通道;实现精准降温,大大提高了通风散热效率,减少了能耗.",
        firmware: "固件升级",
        mobile: "电话",
        tricyclebms: "两轮/三轮车BMS",
        scopeofapplication: "适用范围",
        detailtricycleone: "电池包中的锂电池保护系统(BMS)是电动自行车两轮电动车、三轮电动车、电摩、电动滑板车等产品中不可或缺的模块。常见的BMS板用于电池状态：如电压、电流、温度等的均衡、监控和保护，同时将电池状态信息上报给电动车的中控系统。",
        detailtricycletwo: "傲雷新型智能BMS软件保护板除了常规的硬件功能监测保护外，植入了电池监测保护+可编程控制芯片，通过UART/RS485/CAN三种通讯方式，连接电脑上位机或触摸显示屏、手机APP，对锂电池进行智能化管理。其电池电流电压的多方位数据监测和安全预警为两轮/三轮电动车的整个锂电池系统提供了完整的软硬件双重保护，极大程度上提高了安全性能。",
        automatic: "APP内自动识别系统邮件",
        moreavailable: "更多可用电量",
        flexible: "灵活投资",
        reliable: "安全可靠",
        installation: "安装简单",
        quickstart: "快速开局",
        perfectly: "完美兼容",
        weixin: "微信",
        withsingle: "具有单体电压数据采集、总电压数据采集、电流采集、温度采集",
        withcomplete: "具有完备的故障等级报警功能，包括电压、电流、温度等故障报警",
        withsoc: "具有SOC估算功能",
        withcharge: "具有充放电控制功能",
        withpassive: "具有被动均衡管理功能，提高电池组一致性",
        systemswitch: "系统开关无源机械触点",
        thecurrentacquisition: "注：电流采集分流器方案可选温度补偿，降低温度对分流器的采集精度影响",
        multiphaseinverters: "同时匹配用户单相和三相逆变器",
        lithium: "磷酸铁锂电芯（LFP）",
        powermodule: "12kg功率模块",
        qq: "QQ",
        batterymodule: "50kg电池模块",
        discharge: "100%深度放电",
        optimization: "模块级充放电优化",
        modulardesign: "2.7kwh模块化设计",
        flexibleexpansion: "2.7-13.5kwh灵活扩展",
        consultation: "合作咨询:",
        busnissmailbox: "商务部邮箱",
        servicemailbox: "业务部邮箱",
        address: "地址",
        about: "关于公司",
        contact: "联系方式",
        product: "产品详情",
        weixinapp: "微信小程序",
        androidapp: "安卓版下载",
        global: "覆盖全球",
        target: "研究创新",
        onlineenquiry: "在线询盘",
        contactleague: "合作加盟",
        BMUmanages: "BMU管理32串的一个电池包，磷酸铁锂或者三元电池,额定放电40A-100A（最大持续）,充电40A-100A（最大持续）,有均衡管理。带LED电量显示，带WIFI、RS485、CAN通讯（默认标配），BCU最多支持5个电池包串联，电池簇系统无需第三层硬件最多管理4个BCU并联。",
        features: "产品特点",
        parameter: "技术参数",
        mainfeatures: "主要功能特点",
        PCsoftwarewith: "具有云端监控的上位机软件，具有WIFI通讯接口，读取单体电池电压、电流、温度、SOH、SOC、整组容量、充放电循环次数、充电截止电压、放电截止电压、最大充电限流值、最大放电限流值、电池状态、累计充电能量和放电能量等信息。",
        electrical: "电气特性",
        maximum: "最大适用范围",
        enterprise: "企业简介",
        innovate: "研究创新",
        scheme: "解决方案",
        chargeovervoltage: "充电过压、放电欠压、充电过流、放电过流、充电过温、放电过温、充电低温、放电低温、绝缘故障、电压传感器故障、电流传感器故障、温度传感器故障、版本匹配性保护，具有硬件全冗余二次保护。",
        adaptation: "应用范围",
        highvoltageenergy: "高压储能电池，电动叉车、电动拖车和AGV车机器人等动力电池。",
        theinterstring: "串间均衡和模块间均衡电路受温度控制，防止均衡电路严重发热。",
        currently: "目前拥有",
        integralalgorithm: "积分算法电量计显示功能，带有温度补偿和自学习算法等。",
        voltagedifference: "压差保护，任意两节电芯之间的电压差超过0.5V（固定值）,充放电保护，且告警。",
        pioneering: "率先发展清洁长寿命能源",
        cooperation: "与以色列电力技术公司深度合作",
        stableandmature: "稳定成熟的技术团队和创新能力",
        energystoragebattery: "储能电池箱",
        bmsbattery: "智能家储BMS",
        twothreewheeledvehicle: "2/3轮电动车BMS",
        theprotection: "保护参数可灵活修改，保存在存储芯片内，且数据可保存50年不丢失。",
        cloudmanage: "云平台管理",
        wificommunication: "WiFi通讯模块",
        region: "深圳市宝安区新安街道海富社区45区鸿都商务大厦A栋212",
        bmsmemo: "电池管理系统(BatteryManagementSystem，缩写BMS)是对电池进行管理的系统，通常具有量测电池电压的功能，防止或避免电池过放电、过充电、过温等异常状况出现。随着技术发展，已经逐渐增加许多功能。",
        copyright_cn: "Copyright C 2002-2023 深圳市傲雷新能源科技有限公司.网站备案许可证号：",
        copyright_com: "Copyright C 2002-2023 深圳市傲雷科技发展有限公司.网站备案许可证号：",
        arayabout: "ARAY POWER的设计，测试和制造，均符合全球标准。不管是欧洲英国法国意大利还是巴西、印度、菲律宾。ARAY power都可以笑傲面对不同的外界环境，默默的为人类服务。",
        abountmemo: "2008年，我们开始进入锂电池管理和应用的研究领域，从最早的锂电池替代铅酸电池，到UPS长寿命锂电池BMS，到长续航和更安全的两轮/三轮动力电池BMS，强大的叉车高压动力BMS，具有高循环时间和安全要求的欧美光伏家用储能BMS。高压BMS中的工业和商业储能，浓缩了我们15年的点滴积累。",
        abountmemodetailed: "碳中和是人类发展的唯一途径，锂电池组的脑BMS必将得到广泛应用。我们已经掌握了高效SOC核心算法、物联网、云和微电网。让我们重新让地球安静下来，一起工作。",
        maturesecurity: "安全措施成熟",
        remotecontrol: "远程操控",
        realtime: "实时监测",
        longlasting: "使用寿命长",
        highvoltage: "高压电路",
        stackable: "可叠加备份",
        cloudtextone: "在世界任何角落使用",
        cloudmemoone: "无论身在何处，只要有wifi连接，都可以轻松登录傲雷云系统，都可以查询当前的产量，节省的资料等需要实时了解的情况。",
        cloudtexttwo: "电池管理",
        cloudmemotwo: "使用傲雷云平台实时检查电池状态，使用一系列报告工具查看实时数据及历史表现。",
        cloudtextthree: "设备管理",
        cloudmemothree: "使用傲雷云平台实时检查设备运行状态，可以根据状态情况进行参数设置调整。",
        cloudtextfour: "报表管理",
        cloudmemofour: "傲雷云平台会根据客户的需求定期将客户需求阶段内的运行状态生成报表供客户分析，也将在运行过程中出现告警的状态实时生成报表，实时提供给客户。",
        platformone: "实时显示",
        platformtwo: "远程功能控制",
        platformthree: "手机APP，小程序或电脑网页端登录",
        platformfour: "实时监控电量，智能调配用电情况",
        internet: "互联网",
        bigdata: "大数据",
        lowcost: "低成本",
        safeuse: "安全使用",
        securityalarm: "安全报警",
        communicationcontrol: "通讯控制",
        remotecontrol: "远程控制",
        upgradepowerfailure: "升级断电",
        lowcostandsafeuse: "低成本安全使用",
        remotecontrolupgrade: "远程控制升级断电",
        tricycleimgdetailed1: "智能均衡算法基于电流对时间计分准确计算电池剩余容量、充入电量和耗电量，soc核酸准确，误差在2%左右，不超3%。",
        tricycleimgdetailed2: "待机时保持省电低电流状态，待机电流控制在8毫安左右，低电休眠状态电流控制在微安级，让电池续航更高，使用更安全，寿命更长，运营成本更低。",
        tricycleimgdetailed3: "当电芯出现过充、过放、电芯温度过高、充电异常、车辆位置异常等非正常情况时，会触发相应的温度过高警报、电压过高警报、短路警报、寻车警报、充放电MOS损坏报警。",
        tricycleimgdetailed4: "通讯端口随时连接电脑端平台管理，可实时监控、查看及控制电池，发送指令容量设置、位置查询、车辆状态控制。",
        tricycleimgdetailed5: "支持手机APP/电脑在线远程充电与断电，支持程序升级，随时控制电池信息及参数设置修改。",
        keywords: {
            home: "傲雷储能首页",
            storage: "傲雷储能电池箱,储能电池箱",
            bms: "傲雷储能BMS电池板,BMS电池板",
            tricycle: "傲雷新型智能两轮/三轮电动车BMS软件保护板两轮/三轮电动车BMS,云平台",
            cloud: "傲雷储能云平台,云平台",
            wifi: "傲雷储能WiFi通讯模块,WiFi通讯模块",
            aboutus: "傲雷储能关于我们,关于我们"
        },
        description: {
            home: "傲雷储能首页,傲雷储能,安全可靠,灵活投资,安装简单,快速开局,完美兼容",
            storage: "傲雷储能官网,傲雷储能,新型储能电池箱包括散热装置",
            bms: "傲雷储能官网,傲雷储能,电池管理系统,安全措施成熟,远程操控,实时监测,高压电路,使用寿命长,可叠加备份",
            tricycle: "傲雷新型智能BMS软件保护板除了常规的硬件功能监测保护外，植入了电池监测保护+可编程控制芯片，通过UART/RS485/CAN三种通讯方式，连接电脑上位机或触摸显示屏、手机APP，对锂电池进行智能化管理。其电池电流电压的多方位数据监测和安全预警为两轮/三轮电动车的整个锂电池系统提供了完整的软硬件双重保护，极大程度上提高了安全性能。",
            cloud: "傲雷储能官网,傲雷储能,云平台,实时显示,远程功能控制,手机APP，小程序或电脑网页端登录,实时监控电量，智能调配用电情况",
            wifi: "傲雷储能官网,傲雷储能,WiFi通讯模块,可实现本地配置,同时WiFi模块还可远程监控组网,实现峰谷负荷调度",
            aboutus: "傲雷储能官网,傲雷储能,关于我们,储能电池箱,BMS电池,云平台管理,WiFi通讯"
        },
        languages: {
            china: "中文",
            england: "英语",
            germany: "德语",
            france: "法语",
            italy: "意大利语"
        },
        customer: "尊敬的客户:",
        form_info: "您好!请填写以下信息,",
        form_desc: "为必填项,提交后信息将以邮件形式发送到信箱，我们将会与您保持联系,谢谢!",
        join_apply: "加盟申请",
        form_title: {
            product_name: "产品名称",
            contact_user: "联系人员",
            mobile_phone: "联系电话",
            email_address: "电子邮件",
            company_name: "公司名称",
            country_area: "国家地区",
            detial_desc: "详情描述"
        },
        valid_message: {
            product_name: "请选择产品名称",
            contact_user: "请输入联系人员",
            mobile_phone: "请输入联系电话",
            email_address: "请输入电子邮件",
            company_name: "请输入公司名称",
            detial_desc: "请输入详情描述,介于10到2000字符"
        },
        select_txt: "请选择",
        submit: '提交',
        online_services: '在线客服',
        online_click: '在线咨询,请点我',
        hotline: "电话咨询:",
        weixinhot: "微信咨询:",
        portablepower: {
            powertitle: "户外储能电源",
            subtitle1: "轻量化设计,轻巧便携,使用方便,启动只需轻轻一按即可",
            subtitle2: "无烟无噪,安全环保,端口齐全,充电速度快,让您用电无忧",
            subtitle4: "安全,高效,智能,全新的AI安全预警系统,为您的工作生活保驾护航",
            subtitle3: "皮实耐用,适应性强,耐高低温,承受-20°C~60°C的恶劣环境均可正常工作",
            pullstoragepower: "拉杆式户外电源",
            pullstoragedesc: "全新便携式移动电源拉杆箱采用大容量超安全磷酸铁锂电池，锂电池应用到户外应急电源系统，克服了现有产品的笨重及环境污染，重量轻、体积小、方便移动，便于携带，供最佳户外使用便利性。便携式移动电源使用先进电池管理系统（BMS）增加系统性能，全程监控运行状况，延长使用寿命。拥有由内而外多重防护机制，短路保护，过热保护，过压保护，过放保护，欠压保护，过载保护，确保使用安全。同时拉杆箱储能电源外观时尚感十足，符合人体工学，优化出行体验，人体工程结构的外观设计能够更方便于用户携带以及运输。",
            pullpowertitle: "便携式移动电源",
            pullsubtitle1: "采用大容量超安全磷酸铁锂电池，锂电池应用到户外应急电源系统，克服了现有产品的笨重及环境污染，重量轻、体积小、方便移动，便于携带，供最佳户外使用便利性。",
            pullsubtitle2: "使用先进电池管理系统（BMS）增加系统性能，全程监控运行状况，延长使用寿命。拥有由内而外多重防护机制，短路保护，过热保护，过压保护，过放保护，欠压保护，过载保护，确保使用安全。",
            pullsubtitle3: "交流220V/110V纯正弦波输出，采用交流纯正弦波输出，克服了方波，修正波不能带电机类感性负载，转换效率低等特点。",
            pullsubtitle4: "拉杆箱式便携式UPS电源自充性能也同样强大，支持交流充电，太阳能充电，车载快充多种充电方式，灵活面对不同场合补充电力需求。",
            productfeature: "产品特性",
            safefeaturetitle: "安全耐用,适应性强",
            powerfeaturetitle: "快速充电,高效逆变技术",
            aifeaturetitle: "智能安全预警系统",
            lightweighttitle: "轻量化人体工程学设计",
            safesubtitle1: "无极耳磷酸铁锂电池,低内阻,不起火,不爆炸",
            safesubtitle2: "电池寿命预估主动算法,主动提高电池安全",
            safesubtitle3: "自复位慢充,充电更稳定,输出口短路保护设计",
            powersubtitle1: "高效双向逆变技术,充电最快达80%/h",
            powersubtitle2: "工业级设计,DSP系统控制,逆变效率高达93%",
            powersubtitle3: "能量密度高体积小,使用便捷,自动升维逆变效率",
            aisubtitle1: "电芯安全AI预警系统,全生命周期定期检测技术",
            aisubtitle2: "智能判读电池充电启停状态,随时掌握充电信息",
            lightweightsubtitle1: "人体工程学轻量化设计,绿色出行,轻巧便携",
            lightweightsubtitle2: "APP在线交互,信息可视化,工作状态一目了然",
            productparams: "性能参数"

        }
    }
}
export default zh


// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh.js